<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <b-link :to="{name:'dashboard'}">Admin</b-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{name}} ({{uid}})</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <admin-entry-card
            v-for="entry in entries"
            :key="entry.eid"
            :entry="entry"
            :photos="entry.photos"
            :uid="uid"
            :name="name"
            class="mb-3"
          />
        </div>
        <div class="col user-wrapper">
          <admin-user-show :user="user" :uid="uid" :name="name" :email="email"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AdminEntryCard from '@/components/admin/AdminEntryCard.vue'
import AdminUserShow from '@/components/admin/AdminUserShow.vue'
export default {
  name: 'list-entries',
  props: ['uid', 'name', 'email'],
  components: { AdminEntryCard, AdminUserShow },
  computed: {
    ...mapGetters({
      entryCount: 'entry/entryCount'
    }),
    ...mapState({
      entries: state => state.entry.entries,
      user: state => state.user.user
    })
  },
  methods: {
    hidden() {
      // console.log('In the hidden function:' + this.entry.eid)
    }
  },
  mounted() {
    this.$store.dispatch('entry/fetchEntries', this.uid)
  }
}
</script>

<style scoped>
h1 {
  margin-top: 1em;
}
.user-wrapper {
}
</style>
